<label class="form-zone-label">Surcharge d'attributs</label>
<fa-icon
    [icon]="faCircleInfo"
    class="info-icon"
    hubToolTip="Ce tableau permet de specifier les attributs du dossier de rattachement dont la valeur peut être surchargée par la valeur du même attribut provenant du mail reçu.<br> La surcharge de l'attribut peut être conditionnée par une condition : <ul><li><b>Toujours</b> : L'attribut est toujours surchargé, quelle que soit la valeur de l'attribut cible et de l'attribut source<li><li><b>Si l'attribut de destination n'est pas renseigné</b> : L'attribut est surchargé uniquement si la valeur de l'attribut du dossier cible n'est pas renseignée.</li><li><b>Si l'attribut source est renseigné</b> : L'attribut est surchargé uniquement si la valeur de l'attribut du document reçu est renseignée</li></ul>"
    tooltipPosition="right"></fa-icon>
<div class="table-container">
    <table #resultsTable mat-table matSort class="table-columns-definition" [dataSource]="attributesDatasource">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef [ngClass]="{ 'no-action': disabled }">Attribut</th>
            <td mat-cell *matCellDef="let element" [ngClass]="{ 'no-action': disabled }">{{ element.attributeName }}</td>
        </ng-container>
        <ng-container matColumnDef="condition">
            <th mat-header-cell *matHeaderCellDef [ngClass]="{ 'no-action': disabled }">Condition</th>
            <td mat-cell *matCellDef="let element" [ngClass]="{ 'no-action': disabled }">{{ element.overrideCondition | listItem: _overrideConditions }}</td>
        </ng-container>

        @if (!disabled) {
            <ng-container matColumnDef="action" stickyEnd>
                <th mat-header-cell *matHeaderCellDef class="action-column">
                    <mat-icon id="addIcon" class="icon-add-filters" (click)="onAddAttribute()" matTooltip="Ajouter un attribut" matTooltipPosition="below">add</mat-icon>
                </th>
                <td mat-cell *matCellDef="let row" class="action-column">
                    <mat-icon (click)="onEditAttribute(row)" matTooltip="Éditer l'attribut" matTooltipPosition="below">edit</mat-icon>
                    <mat-icon (click)="onDeleteAttribute(row.attributeId)" matTooltip="Supprimer l'attribut" matTooltipPosition="below">delete</mat-icon>
                </td>
            </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="attributesTableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: attributesTableColumns"></tr>
    </table>
</div>
